import React from "react";
import './TodoLoading.css'

function TodoLoading(){
    return(
        <section class="dots-container">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
        </section>
    )
}
export { TodoLoading };